export class DateTimeEditorOptions{
    constructor(){
    }

    public defaultDate: boolean;
    public emitEmptyDate?: boolean;
    public todayDate?: string;
    validation?: (val: string, item: any, editor: any, outerData: string) => Slick.ValidateResults;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/date-time-editor-options.ts